import { useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Logo from "../../assets/icons/farm.png";
import { Link } from "react-router-dom";

const navigation = [
  {
    name: "Home",
    href: "#",
    current: true,
  },
  {
    name: "How It Works?",
    href: "#how",
    current: false,
  },
  {
    name: "Including",
    href: "#including",
    current: false,
  },
  {
    name: "Technology",
    href: "#TechOverview",
    current: false,
  },
  {
    name: "Features",
    href: "#Features",
    current: false,
  },
  {
    name: "Team",
    href: "#Team",
    current: false,
  },
  {
    name: "Sens 1",
    href: "https://drive.google.com/file/d/1RZMafnd5vhqGfPc6xXajrE1mT2UnDw39/view?usp=sharing",
    current: false,
    external: true,
  },
  {
    name: "Benefits",
    href: "https://drive.google.com/file/d/1k-hzmGJXr2GQqdHtEOkrldg_NkZdsD_R/view?usp=sharing",
    current: false,
    external: true,
  },
];

export default function Hero() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileNavigation = (href) => {
    setMobileMenuOpen(false);

    if (!href.startsWith("#")) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const element = document.querySelector(href);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });
  };

  return (
    <div>
      {/* Header */}
      <header className="fixed inset-x-0 top-0 z-50 border-b-2 bg-white">
        <nav
          aria-label="Global"
          className="flex items-center justify-between p-3 lg:px-8"
        >
          {/* Logo */}
          <div className="flex lg:flex-1">
            <a
              href="/"
              className="-m-1.5 flex items-center justify-center gap-2 p-1.5"
            >
              <span className="sr-only">FARM</span>

              <img className="h-14 w-auto" src={Logo} alt="FARM" />
            </a>
          </div>

          {/* Mobile Header Buttons */}
          <div className="flex lg:hidden">
            <div className="mr-4 flex items-center justify-center gap-5 text-center">
              <a
                href="https://users.farm-sens.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl bg-yellow-400 px-2 py-1 text-base leading-7 text-gray-900"
              >
                FARM App
              </a>

              <Link
                to="/contact"
                className="rounded-xl bg-blue-600 px-3 py-1 text-sm leading-6 text-white"
              >
                Shop
              </Link>
            </div>

            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 font-semibold text-gray-700"
            >
              <span className="sr-only">Open main menu</span>

              <Bars3Icon aria-hidden="true" className="h-9 w-9" />
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target={item.external ? "_blank" : undefined}
                rel={item.external ? "noopener noreferrer" : undefined}
                className="
                  border-b-2
                  border-white
                  text-sm
                  font-semibold
                  leading-6
                  text-gray-600
                  transition-all
                  duration-150
                  hover:border-green-700
                "
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* Desktop Buttons */}
          <div className="hidden gap-3 lg:flex lg:flex-1 lg:justify-end">
            <Link
              to="/contact"
              className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold leading-6 text-white"
            >
              Shop
            </Link>

            <a
              href="https://users.farm-sens.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-xl bg-yellow-400 px-4 py-2 text-sm font-semibold leading-6 text-gray-900"
            >
              FARM App
            </a>
          </div>
        </nav>

        {/* Mobile Menu */}
        <Dialog
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
          className="lg:hidden"
        >
          <div className="fixed inset-0 z-40" />

          <DialogPanel
            className="
              fixed
              inset-y-0
              right-0
              z-50
              w-full
              overflow-y-auto
              bg-white
              px-3
              py-3
              sm:max-w-sm
              sm:ring-1
              sm:ring-gray-900/10
            "
          >
            {/* Mobile Menu Header */}
            <div className="flex items-center justify-between border-b pb-8">
              <a
                href="/"
                onClick={() => setMobileMenuOpen(false)}
                className="-m-1.5 flex items-center justify-center gap-2 p-1.5"
              >
                <span className="sr-only">FARM</span>

                <img className="h-14 w-auto" src={Logo} alt="FARM" />
              </a>

              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
              >
                <span className="sr-only">Close menu</span>

                <XMarkIcon aria-hidden="true" className="h-10 w-10" />
              </button>
            </div>

            {/* Mobile Navigation */}
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      target={item.external ? "_blank" : undefined}
                      rel={item.external ? "noopener noreferrer" : undefined}
                      onClick={(event) => {
                        if (!item.external) {
                          event.preventDefault();
                          handleMobileNavigation(item.href);
                        } else {
                          setMobileMenuOpen(false);
                        }
                      }}
                      className="
                        mx-3
                        block
                        rounded-lg
                        px-3
                        py-2
                        text-base
                        font-semibold
                        leading-7
                        text-gray-900
                        transition-colors
                        hover:bg-gray-50
                      "
                    >
                      {item.name}
                    </a>
                  ))}
                </div>

                {/* Mobile Buttons */}
                <div className="flex w-full justify-center gap-5 py-6 text-center">
                  <a
                    href="https://users.farm-sens.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setMobileMenuOpen(false)}
                    className="
                      rounded-xl
                      bg-yellow-400
                      px-4
                      py-2
                      text-base
                      font-semibold
                      leading-7
                      text-gray-900
                    "
                  >
                    FARM App
                  </a>

                  <Link
                    to="/contact"
                    onClick={() => setMobileMenuOpen(false)}
                    className="
                      rounded-xl
                      bg-blue-600
                      px-4
                      py-2
                      text-sm
                      font-semibold
                      leading-6
                      text-white
                    "
                  >
                    Shop
                  </Link>
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      {/* Hero */}
      <div className="relative isolate pt-14">
        <div
          className="
            background-hero
            mx-auto
            flex
            justify-center
            px-6
            py-24
            sm:py-32
            lg:items-center
            lg:px-8
            lg:py-40
          "
        >
          <div
            className="
              mx-auto
              flex
              flex-col
              items-center
              justify-center
              rounded-2xl
              border
              border-gray-400
              bg-black/20
              px-4
              py-16
              shadow-md
              backdrop-blur-md
              md:px-16
            "
          >
            <img
              alt="FARM logo"
              src={Logo}
              className="h-24 w-24 lg:h-32 lg:w-32"
            />

            <h1
              className="
                mt-10
                max-w-xl
                text-3xl
                font-bold
                tracking-normal
                text-white
                sm:text-6xl
                md:text-5xl
              "
            >
              Smart Agriculture
            </h1>

            <h3
              className="
                mt-10
                cursor-pointer
                text-xl
                font-semibold
                text-gray-400
                underline
                underline-offset-8
                transition-all
                duration-300
                hover:text-white
                md:text-2xl
              "
            >
              Solution for Sustainability
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}
